import styled, { css } from 'styled-components';
import DefaultOldWestwingStudioLogo, {
    WestwingStudioLogo as DefaultWestwingStudioLogo,
} from '@westwing/ui-kit/Icons/Svgs/WestwingStudioLogo';
import { forTablet, forDesktop, underTablet } from '@westwing/ui-kit/breakPoints';
import Heading from '@ids/components/Typography/Heading';
import GenericMedia from '@ids/components/Media';
import { withAspectRatio } from '@ids/components/Layout/AspectRatio';
import { scrollMarginToSection } from '@ids/components/Layout/utils';

export const HeroSection = styled.section`
    text-align: center;
    margin-bottom: 30px;

    ${scrollMarginToSection}

    ${forDesktop`
        height: 500px;
        display: flex;
        margin-bottom: 60px;
    `}
`;

export const TextWrapper = styled.div<{
    $color?: string;
    $backgroundColor?: string;
}>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 25px;
    color: ${({ theme, $color }) => $color ?? theme.colors.charcoal100};
    background: ${({ theme, $backgroundColor }) => $backgroundColor ?? theme.colors.white};

    ${forTablet`
        order: 1;
        padding: 40px 75px;
        flex-basis: 29%;
    `}

    ${forDesktop`
        min-width: 450px;
    `}
`;

export const MediaWrapper = styled.div<{ $backgroundColor?: string; ratio: number }>`
    position: relative;
    line-height: 0;
    background: ${({ theme, $backgroundColor }) => $backgroundColor ?? theme.colors.white};

    ${underTablet`
        ${withAspectRatio}
    `}

    ${forTablet`
        order: 2;
        flex-basis: 71%;
        height: 350px;
    `}

    ${forDesktop`
        height: 500px;

    `}
`;

export const Media = styled(GenericMedia.Image)`
    width: 100%;
    position: relative;
    color: ${({ theme }) => theme.colors.skeleton01};
    height: 100%;

    &[data-type='image'] {
        background: ${({ theme }) => theme.colors.skeleton01};
    }
`;

const westwingLogoStyles = css`
    margin: 0 auto 15px;

    svg {
        width: 200px;
    }

    ${forTablet`
        margin-bottom: 20px;

        svg {
            width: 300px;
        }
    `}

    ${forDesktop`
        margin-bottom: 40px;
    `}
`;

/** @deprecated */
export const OldWestwingStudioLogo = styled(DefaultOldWestwingStudioLogo)`
    ${westwingLogoStyles}
`;

export const WestwingStudioLogo = styled(DefaultWestwingStudioLogo)`
    ${westwingLogoStyles}
`;

export const Title = styled(Heading)`
    width: min(470px, 100%);
    margin: 0 auto 15px;

    ${forTablet`
        margin-bottom: 20px;
    `}

    ${forDesktop`
        margin-bottom: 10px;
    `}
`;
